import React, {useEffect} from 'react';
import "./Contact.css";
import AOS from "aos";
import "aos/dist/aos.css";

function Contact() {
    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div className="Contact" id="contact">
            <h2 data-aos={"fade-up"} data-aos-delay="300">04. What's Next?</h2>
            <h1 data-aos={"fade-up"} data-aos-delay="500">Get In Touch</h1>
            <p data-aos={"fade-up"} data-aos-delay="600">Although I'm not currently looking for any new opportunities, my inbox is always open. Whether you have a question or just want to say hi, I'll try my best to get back to you!</p>

            <a data-aos={"fade-up"} data-aos-delay="700">Say Hello</a>
        </div>
    )
}

export default Contact
